import React, { useEffect, useReducer } from "react";
import { Button, Checkbox, Col, Form, Row, Select,message} from "antd";
import ComponentsBreadcrumb from "../../layout/componentsBreadcrumb";
import { useHistory } from "react-router-dom";
import { formState, formReducer } from "./reducer";
import { useDispatch, useSelector } from "react-redux";
import { getTypes, getLooups, getNetworkLu, savePayment ,geCustomertPaymentDetails} from './service'
import NumberFormat from "react-number-format";
import { cryptoMaxAllowedDecimals, validateContentRule } from "../../utils/custom.validator";
import { setPaymentDetails } from "../../reducers/paymentlinkReducer";
import AppAlert from "../../shared/appAlert";
import Loader from "../../shared/loader";
import SpinLoader from "../../shared/spinLoader";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { isErrorDispaly } from "../../shared/validationsAndExceptions/apiExceptions";
const { Option } = Select;

const CreatePaymentLink = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const reducerDispatch = useDispatch();
  const { pathname } = useLocation();
  const _id = pathname?.split('/')[2];
  const _merchantName = pathname?.split('/')[3];
  const breadCrumbList = [
    { id: "1", bname: "Payment Artha",url : '/dashboard' },
    { id: '2', bname: 'Payment Links',url : '/paymentlinks'},
    { id: '3', bname: _id === 'create' ? 'Create Payment link' : _merchantName}
  ];
  const customerInfo = useSelector((info) => info.userConfig.userProfileInfo);  
  let _paymentDetails = useSelector((paymentDetails) => paymentDetails.PayMentReducer.paymentDetails);
  const [localState, localDispatch] = useReducer(formReducer, formState);
  useEffect(() => {
    initialize();
     if(_paymentDetails && _id !=='create'){
      localDispatch({ type: 'setValues', payload: _paymentDetails });
      form.setFieldsValue(_paymentDetails);
      reducerDispatch(setPaymentDetails(null));
    }
  }, [])
  const initialize = async () => {
    localDispatch({ type: 'setIsLoading', payload: 'initialLoading' });
    await Promise.all(_id !=='create' ? [getMerchantsLu(), getInvocieTypes(), getCurrency(),getPaymentDetails()] : [getMerchantsLu(), getInvocieTypes(), getCurrency()] ).then(([merchants, types, currencies,_paymentDetails])=>{
      let _obj = { ...localState.lookups }
      _obj.merchantLookup = merchants;
      _obj.typeLookup = types;
      _obj.currencyLookup = currencies;
      if(_id==='create'){
        localDispatch({ type: 'setLookups', payload: _obj });
      }
      if(_id !=='create'){
        localDispatch({ type: 'setValues', payload: _paymentDetails });
     form.setFieldsValue(_paymentDetails)
     getNetworks(_paymentDetails.currency,_obj)
 }
    }).catch(error=>{
      setErrorMessages(error);
    }).finally(()=>{
      localDispatch({ type: 'setIsLoading', payload: '' });
    })
  }
  const getMerchantsLu = async () => {
    try {
      let response = await getLooups('Merchant/merchantslookup', customerInfo?.id);
      if(response.success){
        return  response.data
      }else{
        return response.error
      }
    }
    catch (error) {
      setErrorMessages(error);
    }
  }
  const getCurrency = async () => {
    try {
      let response = await getLooups('Merchant/CurrencyLookUp', customerInfo?.id);
      if(response.success){
        return  response.data
      }else{
        return response.error
      }
    }
    catch (error) {
      setErrorMessages(error);
    }
  }
  const getInvocieTypes = async () => {
    try {
      return await getTypes('Merchant/paymentlookup');
    }
    catch (error) {
      setErrorMessages(error);
    }
  }
  const getNetworks = async (currency,paymentLu) => {
    try {
      localDispatch({ type: 'setIsLoading', payload: 'network' });
      let response = await getNetworkLu('Merchant/NetWorkLookUp', currency, customerInfo?.id);      
      let _obj = paymentLu ? {...paymentLu} : {...localState.lookups }
      if(response.success){
        _obj.networkLookup = response.data
      }else{
         _obj.networkLookup = response.error;
      }
      localDispatch({ type: 'setLookups', payload: _obj })
    }
    catch (error) {
      setErrorMessages(error);
    }
    finally {
      localDispatch({ type: 'setIsLoading', payload: '' });
    }
  }
  const handleCreate = async (val) => {
    const trimValues = (obj) => {
      let trimmedObj = {};
      Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === 'string') {
          trimmedObj[key] = obj[key].trim();
        } else {
          trimmedObj[key] = obj[key];
        }
      });
      return trimmedObj;
    };
    const values = trimValues(val);
    values.isPayCommission = localState?.values?.isPayCommission;
    if(Number(values?.amount) == 0 && values?.invoiceType != 'Static'){
      localDispatch({ type: 'setErrors', payload: 'Amount must be greater than zero' });
      return;
    }   
     let _merchant = localState.lookups.merchantLookup?.find((merchant) =>{
         return merchant.id === values.merchantId
    });

    try {
      localDispatch({ type: 'setIsLoading', payload: 'btnLoader' });
      let response = await savePayment('Merchant/createpaymentlinks', values, customerInfo?.id, _id,_merchant?.name);
      if (response) {
        let _obj={
                 ...values,
                 walletAddress: response?.walletAddress,
                 amountInUsd : response?.amountInUsd,
                 merchantName: response?.merchantName,
                 id : response?.id,
                 status : response?.status,
                 commission :response?.commission,
                 isPayCommission : response?.isPayCommission,
                 paymentLink:response?.paymentLink
        }
        reducerDispatch(setPaymentDetails(_obj));
        message.success({
          content: _id === 'created' ? "Payment link created successfully!" : "Payment link updated successfully!",
          className: 'custom-msg',
          duration: 1
        });
        let __id = _id ==='create' ? response?.id : localState.values?.id
        history.push(`/createpaymentinvoice/${__id}/${response?.merchantName}`)
      }else{
        setErrorMessages(response?.data);
        return;
      }
    }
    catch (error) {
      setErrorMessages(error)
    }
    finally{
      localDispatch({ type: 'setIsLoading', payload: '' });
    }
  };

  const setErrorMessages = (error) => {
    let _obj = { ...localState.errors };
    _obj.errors = error;
    if (error === null) {
      localDispatch({ type: 'setErrors', payload: null });
  } else {
      _obj.errors = error;
      localDispatch({ type: 'setErrors', payload: isErrorDispaly(_obj) });
    }
  }
  const setField = (field, value) => {
    form.setFieldsValue({ [field]: value });
    let _obj = { ...localState.values };
    if(field === 'currency'){
      form.resetFields(['networkName'])
      _obj['networkName'] = '';
      getNetworks(value);
    }
    else if(field === 'invoiceType'){
      form.resetFields(['amount'])
      _obj['amount'] = null;
    }
    _obj[field] = value;
    localDispatch({ type: 'setValues', payload: _obj })
  };
  const getPaymentDetails = async() =>{
      try{
        localDispatch({ type: 'setIsLoading', payload: 'initialLoading' });
        return await geCustomertPaymentDetails('Merchant/paymentdetail',_id);        
      }catch(error){
        setErrorMessages(error)
      }
      finally{
        localDispatch({ type: 'setIsLoading', payload: '' });
      }
  }
  const handleRedirect = () => {
    history.push('/paymentlinks');
  };
  const getIsDisabled = (_paymentId, isPaid) => {
    if (_paymentId !== 'create') {
      return !isPaid;
    }
    return false;
  };
  const shouldRenderButton = (paymentId, _isPaid) => {
    if (paymentId !== 'create') {
      return _isPaid;
    }
    return true; 
  };
  return (
    <>
      <ComponentsBreadcrumb breadCrumbList={breadCrumbList} />
      {localState.isLoading === 'initialLoading' && <Loader/>}
      {localState.errors && (
            <div className="alert-flex" style={{ width: "100%" }}>
                <AppAlert
                    className="w-100 "
                    type="warning"
                    description={localState.errors}
                    showIcon
                />
                <span className="icon sm alert-close" onClick={() => setErrorMessages(null)}></span>
            </div>
        )}
      <div className="layout-bg right-panel panel-bg tracnsaction-details">
       
      <div className="form-title mb-24">
          <div className="d-flex align-items-center">
                  <span className="icon lg btn-arrow-back c-pointer" onClick={handleRedirect}></span>
                  <span className="card-title card-head">Create Payment link  </span>
                </div>
                </div>
      {( localState.isLoading !=='initialLoading')&& <div className="transfer-form">
          <Form
            form={form}
            className="payees-form custom-label mb-0 fw-400"
            onFinish={handleCreate}
            scrollToFirstError
          >
            <div className="">
              <Row gutter={[16, 16]} className="">
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <div className={`text-left payee-field p-relative`}>
                    <div className="payee-token p-absolute">
                      <div className="payee-coinselect">
                        <div className="mbl-ellipse">
                          <span className="payee-label">
                            Merchant <span className="text-red">*</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="text-left">
                      <Form.Item
                        name="merchantId"
                        rules={[{ required: true, message: "Is required" }]}
                        className="mb-0"
                        colon={false}
                      >
                        <Select
                          onChange={(e) => setField("merchantId", e)}
                          placeholder="Select Merchant"
                          className="payee-input input-bordered"
                          maxLength={30}
                          disabled={_id !== 'create'}
                        >
                          {localState.lookups.merchantLookup?.map((item, index) => (
                            <Option key={index} value={item.id}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                  <p className="input-note mb-16">The funds paid by your client will be transferred  to your business wallet</p>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <div className="p-relative placehoder-inherit">
                    <Form.Item
                      className="payees-input m-0 error-block"
                      name="invoiceType"
                      placeholder="Select Type"
                      label="Type"
                      colon={false}
                      rules={[
                        { required: true, message: "Is required", whitespace: true },
                      ]}
                    >
                      <Select
                        onChange={(e) => setField("invoiceType", e)}
                        placeholder="Select Type"
                        className="payee-input input-bordered"
                        maxLength={30}
                        disabled={getIsDisabled(_id, localState.values.state === 'Not Paid')}
                      >
                        {localState.lookups.typeLookup?.map((item, index) => (
                          <Option key={index} value={item.name}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                  <p className="input-note mb-16">You can track for each order.</p>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <Form.Item
                    className="payees-input m-0 error-block orderid-input"
                    name="orderId"
                    label="Order ID"
                    colon={false}
                    rules={[
                      { required: true, message: "Is required", whitespace: true },
                      {
                        validator: validateContentRule,
                      },
                    ]}
                  >
                    <input
                      className="payees-input input-bordered text-left pl-18"
                      placeholder="Enter Order ID"
                      type="input"
                      maxLength={100}
                      disabled={_id !== 'create'}
                    />
                  </Form.Item>
                  <p className="input-note">Help to Understand what your client is paying for</p>
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <h3 className="bal-title text-white mb-10 mt-16">
                    Enter amount to pay
                  </h3>
                </Col>


                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                      <div>
                        <Form.Item
                          className= {`payees-input mb-0 ${localState.values.invoiceType === "Static" ? null :'error-block'} amount-label`}
                          name="amount"
                          label="Amount"
                          colon={false}
                          rules={[
                            { required: localState.values.invoiceType === "Static" ? false : true, message: localState.values.invoiceType === "Static" ? null : "Is required" },
                          ]}
                        >
                          <NumberFormat
                            className={'"payee-input input-bordered text-left pl-18'}
                            placeholder="0.00"
                            name={'amount'}
                            isAllowed={cryptoMaxAllowedDecimals}
                            thousandSeparator={true}
                            thousandsGroupStyle='lakh'
                            disabled={(localState.values.invoiceType === "Static" ? true : false ) || ( getIsDisabled(_id, localState.values.state === 'Not Paid') )}
                            allowNegative={false}
                            maxLength = {20}
                            decimalScale={8}
                            onValueChange={(data) => {
                              setField('amount', data.floatValue);
                            }}
                          />
                        </Form.Item>
                      </div>
                      <div className='policy-content terms-text d-flex'>
                    <div className="mb-16">
                      {/* <Form.Item name="isPayCommission" className={`mb-0`} valuePropName="checked">
                        <Checkbox onChange={(e) => setField('isPayCommission', e.target.checked)} disabled = {getIsDisabled(_id, localState.values.state === 'Not Paid')}checked={localState.values.isPayCommission} className="mr-6"></Checkbox>
                        <span className="checkbox-text"><div className='commisions-terms'>Client will pay commission</div></span>
                      </Form.Item> */}
                    </div>
                  </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                      <div className={`text-left payee-field p-relative mb-20`}>
                        <div className="payee-token p-absolute">
                          <div className="payee-coinselect">
                            <div className="mbl-ellipse">
                              <span className="payee-label">
                                Coin <span className="text-red">*</span>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="text-left">
                          <Form.Item
                            className="mb-0"
                            name="currency"
                            rules={[
                              { required: true, message: "Is required", whitespace: true },
                            ]}
                          >
                            <Select
                              className="payee-input input-bordered"
                              placeholder="Select Coin"
                              onChange={(e) => setField('currency', e)}
                              disabled={getIsDisabled(_id, localState.values.state === 'Not Paid')}
                            >
                              {localState.lookups.currencyLookup?.map((item) => (
                                <Option key={item?.id} value={item?.code}>
                                  <span className={`active-coin crypto coin sm ${item?.code.toLowerCase()} mr-6`}></span>
                                  <span>{item?.code}</span>
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </Col>



                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <div className={`text-left payee-field p-relative`}>
                    <div className="payee-token p-absolute">
                      <div className="payee-coinselect">
                        <div className="mbl-ellipse">
                          <span className="payee-label">
                            Network <span className="text-red">*</span>
                          </span>
                        </div>
                      </div>
                    </div>
                    {localState.isLoading === 'network' && <div className="select-spinner-position"><SpinLoader/></div>}
                    <div className={`text-left ${localState.isLoading === 'network' && "select-arrow-hidden" }`}>
                      <Form.Item
                        className="mb-30"
                        name="networkName"
                        rules={[
                          { required: true, message: "Is required", whitespace: true },
                        ]}
                      >
                        <Select
                          className="payee-input input-bordered"
                          placeholder="Select Network"
                          type="input"
                          maxLength={100}
                          disabled={getIsDisabled(_id, localState.values.state === 'Not Paid')}
                          onChange={(e) => setField('networkName', e)}
                        >

                          {localState.lookups.networkLookup?.map((item, idx) => (
                            <Option key={item.id} value={item.name}>
                             <span>{item.name}</span>
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </Col>
              </Row>
              <Form.Item className="mt-30 mb-0">
               {shouldRenderButton(_id, localState.values.state === 'Not Paid') &&  <Button block className="btn-style" htmlType="submit" style={{ marginLeft: '0px',width:"100%" }} loading={localState.isLoading === 'btnLoader'}>
                  {_id === 'create' ? 'Create Payment link' : 'Update Payment link'}<span className="icon lg right-arrow c-pointer" />
                </Button>}
              </Form.Item>
            </div>

          </Form>
        </div>}
      </div>
    </>
  );
};

export default CreatePaymentLink;
